import { Box } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { Outlet } from 'react-router-dom';

export default function UserMainGrid() {
    return (
        <Box
            sx={{ width: "100%" }}
        >
            <Outlet />
        </Box>
    );
}